import { useState } from "react";
import { Cookie, X } from "lucide-react";
import { getCookie, setCookie } from "@/context/ThemeContext";

export function analyticsAllowed() {
  try {
    const c = getCookie("dt-consent");
    if (!c) return false;
    return !!JSON.parse(c).analytics;
  } catch {
    return false;
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !getCookie("dt-consent"));
  const [manage, setManage] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(false);

  if (!visible) return null;

  const save = (prefs) => {
    setCookie("dt-consent", JSON.stringify({ necessary: true, ...prefs }), 180);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[85]" data-testid="cookie-banner">
      <div className="card-dt !bg-dt-bg2/95 backdrop-blur-xl p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-dt-accent shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="font-heading font-semibold text-dt-text text-sm">Cookies at Destiny Tip</p>
            <p className="text-xs text-dt-muted mt-1 leading-relaxed">
              We use strictly necessary cookies to keep you signed in, plus optional analytics to improve the platform.
            </p>
            {manage && (
              <div className="mt-3 space-y-2 text-xs" data-testid="cookie-preferences">
                <label className="flex items-center justify-between gap-3 text-dt-muted">
                  Strictly necessary <span className="text-dt-accent font-semibold">Always on</span>
                </label>
                <label className="flex items-center justify-between gap-3 text-dt-muted cursor-pointer">
                  Analytics
                  <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)}
                         className="accent-[#8DB9E8]" data-testid="cookie-analytics-toggle" />
                </label>
                <label className="flex items-center justify-between gap-3 text-dt-muted cursor-pointer">
                  Marketing
                  <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)}
                         className="accent-[#8DB9E8]" data-testid="cookie-marketing-toggle" />
                </label>
              </div>
            )}
            <div className="mt-4 flex flex-wrap gap-2">
              <button onClick={() => save({ analytics: true, marketing: true })}
                className="btn-glow-hover bg-dt-silver text-dt-bg text-xs font-semibold rounded-full px-4 py-2"
                data-testid="cookie-accept-all">
                Accept All
              </button>
              {manage ? (
                <button onClick={() => save({ analytics, marketing })}
                  className="bg-dt-card border border-dt-border text-dt-text text-xs font-semibold rounded-full px-4 py-2 hover:border-dt-accent transition-colors"
                  data-testid="cookie-save-prefs">
                  Save preferences
                </button>
              ) : (
                <button onClick={() => setManage(true)}
                  className="bg-dt-card border border-dt-border text-dt-text text-xs font-semibold rounded-full px-4 py-2 hover:border-dt-accent transition-colors"
                  data-testid="cookie-manage">
                  Manage Preferences
                </button>
              )}
              <button onClick={() => save({ analytics: false, marketing: false })}
                className="text-dt-muted text-xs px-2 py-2 hover:text-dt-text transition-colors"
                data-testid="cookie-decline">
                Decline optional
              </button>
            </div>
          </div>
          <button onClick={() => save({ analytics: false, marketing: false })} aria-label="Close cookie banner"
            className="text-dt-muted hover:text-dt-text"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
}
